/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Введите текст…',
  'fabric.editor.editorAssistiveLabel': 'Область основного содержимого. Начните печатать, чтобы ввести текст.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Открыть справку'
};